

export const langList = [
    { label: "中文", value: 0 },
      { label: "英文", value: 1 },
];
export const newsList = [
    { label: "公司新闻", value: 0 },
    { label: "行业新闻", value: 1 },
];
export const statusList = [
    { label: "待定", value: 0 },
    { label: "录用", value: 1 },
    { label: "弃用", value: 2 },
]